import { getOnboardingModel } from '../../services/entities/onboardingService'
const OB_FLOW_STEPS = 4
export const onboardingModule = {
  namespaced: true,
  state: {
    data: getOnboardingModel()
  },
  mutations: {
    setKeyValue (state, payload) {
      let { prop, value } = payload
      state.data = { ...state.data, [prop]: value }
    }
  },
  getters: {
    progressBarWidth ({ data }) {
      if (data.currStep >= OB_FLOW_STEPS) {
        return '100%'
      }
      let width = (100 / OB_FLOW_STEPS) * JSON.parse(data.currStep)
      return width.toString() + '%'
    },
    data ({ data }) {
      // Return shallow copy, to avoid mutation out of module scope
      return { ...data }
    },
    isPartnerFlow ({ data }) {
      return data.isPartnerFlow
    },
    isMobile ({ data }) {
      return data.isMobile
    },
    partnerToken ({ data }) {
      return data.partnerToken
    },
    hasAccount ({ data }) {
      return data.hasAccount
    },
    isMultiBusinessFlow ({ data }) {
      return data.isMultiBusinessFlow
    }
  }
}



// WEBPACK FOOTER //
// ./src/RF_store/modules/onboarding.module.js